export default "__VITE_ASSET__B74XGYsH__"